import React from "react";
import { motion } from "framer-motion";
import imgg from "../assets/11.jpg";
import { Link } from "react-router-dom";
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Image slides in from RIGHT
const itemFromRight = {
  hidden: { x: 100, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.8 } },
};

// Content slides in from LEFT
const itemFromLeft = {
  hidden: { x: -100, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.8 } },
};

const CenterSection = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <motion.div
        className="flex flex-col md:flex-row items-center gap-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >

        {/* Left Image */}
        <motion.div
          className="md:w-5/12 w-full"
          variants={itemFromRight}  // slide from right
        >
          <img
            src={imgg}
            alt="Elevator"
            className="w-full h-[500px] rounded-lg shadow-xl object-cover"
          />
        </motion.div>

        {/* Right Content */}
        <motion.div
          className="md:w-7/12 w-full text-center md:text-left"
          variants={itemFromLeft}  // slide from left
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            WVT Touch The Technology
          </h2>
          <h3 className="text-xl text-black font-semibold mb-4">WVT Elevators</h3>
          <p className="text-gray-700 mb-4">
            WVT Elevators is one of the leading ISO 9001: 2015 certified and a government licensed Elevator Company providing expertise solutions in “Moving Technology” and quickly becoming a trusted brand amongst customers in the field of construction.
          </p>
          <p className="text-gray-700 mb-6">
            Over the years, the company has grown under the guidance of both the Directors of the firm who have 30 years of technical experience and 25 years of marketing experience respectively share their entrepreneurial spirit, commitment to highest standards of integrity and ability to inspire people to action.
          </p>

          {/* Button */}
          <button className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-semibold transition shadow-md hover:shadow-lg mb-6">
            <Link to="/about">
            
            View More ›
            </Link>
          </button>

          {/* Modernization Solutions Heading */}
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            Modernization Solutions
          </h3>
          <p className="text-gray-700 font-medium">
            We can refresh your elevators with new features, technology, and aesthetics while ensuring safety, reliability and performance.
          </p>
        </motion.div>

      </motion.div>
    </section>
  );
};

export default CenterSection;
